import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Configuration axios
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intercepteur pour gérer les erreurs
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

// Contact API
export const contactAPI = {
  // Créer un nouveau contact
  create: async (contactData) => {
    const response = await api.post('/contact', contactData);
    return response.data;
  },

  // Récupérer tous les contacts
  getAll: async (params = {}) => {
    const response = await api.get('/contact', { params });
    return response.data;
  },

  // Récupérer un contact par ID
  getById: async (id) => {
    const response = await api.get(`/contact/${id}`);
    return response.data;
  },

  // Mettre à jour un contact
  update: async (id, data) => {
    const response = await api.put(`/contact/${id}`, data);
    return response.data;
  },

  // Supprimer un contact
  delete: async (id) => {
    const response = await api.delete(`/contact/${id}`);
    return response.data;
  },
};

// Stats API
export const statsAPI = {
  // Récupérer les statistiques
  get: async () => {
    const response = await api.get('/stats');
    return response.data;
  },

  // Récupérer les statistiques détaillées
  getDetailed: async () => {
    const response = await api.get('/stats/detailed');
    return response.data;
  },

  // Mettre à jour les statistiques
  update: async (data) => {
    const response = await api.put('/stats', data);
    return response.data;
  },
};

// Health check
export const healthCheck = async () => {
  try {
    const response = await api.get('/health');
    return response.data;
  } catch (error) {
    return { status: 'ERROR', message: 'API indisponible' };
  }
};

export default api;

// Auth API
export const authAPI = {
  // Login
  login: async (credentials) => {
    const response = await api.post('/auth/login', credentials);
    return response.data;
  },

  // Vérifier le token
  verify: async (token) => {
    const response = await api.get('/auth/verify', {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  }
};

// Gallery API
export const galleryAPI = {
  // Récupérer toutes les photos
  getAll: async (params = {}) => {
    const response = await api.get('/gallery', { params });
    return response.data;
  },

  // Récupérer une photo par ID
  getById: async (id) => {
    const response = await api.get(`/gallery/${id}`);
    return response.data;
  },

  // Ajouter une photo (avec token)
  create: async (formData, token) => {
    const response = await api.post('/gallery', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  },

  // Mettre à jour une photo
  update: async (id, data, token) => {
    const response = await api.put(`/gallery/${id}`, data, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  // Supprimer une photo
  delete: async (id, token) => {
    const response = await api.delete(`/gallery/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  }
};